import axios from 'axios';

// Backend API URL
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000';

const API = axios.create({
    baseURL: API_URL,
    withCredentials: true
});

// --- Interceptor to add auth token to secure requests ---
API.interceptors.request.use((req) => {
    const user = localStorage.getItem('user');
    if (user) {
        const token = JSON.parse(user).token;
        req.headers.Authorization = `Bearer ${token}`;
    }
    return req;
});

// --- User API Calls ---
// (No 'api/' prefix needed here because it's in the baseURL)
export const login = (formData) => API.post('api/users/login', formData);
export const register = (formData) => API.post('api/users/register', formData);
export const getUserProfile = () => API.get('api/users/profile');
export const updateUserProfile = (userData) => API.put('api/users/update-profile', userData);
export const updateUserPassword = (passwordData) => API.put('api/users/update-password', passwordData);
export const updateUserAddress = (addressData) => API.put('api/users/update-address', addressData);
export const updateDeliverySettings = (settingsData) => API.put('api/users/delivery-settings', settingsData);

// --- Item API Calls ---
export const getVendorItems = (vendorId) => API.get(`api/items/vendor/${vendorId}`);
export const getAvailableVendorItems = (vendorId) => API.get(`api/items/vendor/${vendorId}/available`);

// --- Order API Calls ---
export const createRazorpayOrder = (orderData) => API.post('api/orders/create-razorpay-order', orderData);
export const placeOrder = (orderData) => API.post('api/orders/place-order', orderData);
export const getUserOrders = (userId) => API.get(`api/orders/user/${userId}`);

// --- Shop Status API Call ---
export const getShopStatus = (vendorId) => API.get(`api/users/shop-status/${vendorId}`);